import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useContext, useRef } from 'react'
import { Stack, Box, Typography, List, ListItem } from '@mui/material'
import { motion } from 'framer-motion'
import { useNavigate, Link } from 'react-router-dom'
import Logo from '../../assets/logo'
import DemoGroupsPage from '../../assets/videos/groups_page.mp4'
import DemoCreateEvent from '../../assets/videos/create_event.mp4'
import DemoEventFeed from '../../assets/videos/event_feed.mp4'


export const Demos = ({}) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <Stack sx={{ width: '100vw', minHeight: '100vh' }} alignItems={'center'}>
            <Stack
                sx={{ width: '100vw', height: 200 }}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Logo width={200} />
            </Stack>

            <Stack
                direction={'column'}
                sx={{ maxWidth: 600, justifyContent: 'center' }}
                style={{ fontSize: 22, marginBottom: 16 }}
            >
                <motion.div style={{ fontSize: 25, fontWeight: 500, marginBottom: 5 }}>
                    Demos
                </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 300, marginBottom: 20 }}>
                    Learn how to use the JoinU app by viewing these demonstrations.
                </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 400, marginBottom: 30 }}>
                    At the bottom of the JoinU screen, you'll find three icons that correspond to the feed, groups, and settings pages. Each of these icons leads to a different section of the app, and below, we provide overviews and demonstrations of what you can expect on these pages.
                </motion.div>
                
                <motion.div style={{ fontSize: 25, fontWeight: 500, marginBottom: 5 }}>
                    Groups Page
                </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 400, marginBottom: 30 }}>
                The "Groups" page on JoinU, accessed via the middle icon at the bottom of the screen, offers a way to explore and join a variety of groups tailored to your interests or affiliations within the Harvard community. This feature includes official university groups that represent various academic, social, and administrative segments of the university, enhancing your academic and professional connections. Additionally, you can create or join both public and private groups, allowing you to connect with friends and peers in a more personalized setting.
                </motion.div>
                <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 30 }}>
                    <video src={DemoGroupsPage} width="50%" controls />
                </motion.div>
                
                <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5 }}>
                    Create Event
                </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 400, marginBottom: 30 }}>
                Events are central to the JoinU experience, with the app providing access to thousands of events around the university. From the Groups page of the app, anyone can create an event under the public friend group, All Harvard Open List 790. However, to post an event from any other group, you must either own the group or hold the role of an event manager. This structure ensures that events are organized and managed by those who have the appropriate authority within each group.
                </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 400, marginBottom: 30 }}>
                    <video src={DemoCreateEvent} width="50%" controls />
                </motion.div>

                <motion.div style={{ fontSize: 20, fontWeight: 500, marginTop: 10, marginBottom: 10 }}>
                    Event Feed
                    </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 400, marginBottom: 30 }}>
                The "Events" page on JoinU, which you can access via the middle icon at the bottom of the screen, organizes events into four categories for easy navigation. The Events page has four tabs across the top. The "All" events tab lists all publicly available events across the platform, offering a comprehensive view of upcoming activities. The "Groups" tab shows events specifically from the groups you have joined, allowing for a personalized event feed. Events that you have shown interest in by clicking "Join" are compiled under the "Joined" tab. Lastly, the "Specials" tab highlights exclusive offers, discounts, and giveaway opportunities, adding value to your event browsing experience.
                </motion.div>
                <motion.div style={{ fontSize: 16, fontWeight: 400, marginBottom: 30 }}>
                    <video src={DemoEventFeed} width="50%" controls />
                </motion.div>
            </Stack>
        </Stack>
    );
};